/* generated by pull.js */
const manifest = {
    "name": "Costume Tool Panel",
    "description": "Adds a tool menu to the costume editor, to manually edit object transforms and properties.",
    "credits": [
        {
            "name": "SharkPool",
            "link": "https://github.com/SharkPool-SP/"
        },
        {
            "name": "DogeisCut",
            "link": "https://github.com/DogeisCut/"
        }
    ],
    "userscripts": [
        {
            "url": "userscript.js"
        }
    ],
    "tags": ["editor", "recommended"],
    "enabledByDefault": true,
    "dynamicEnable": true,
    "dynamicDisable": false
};
export default manifest;
